export default __webpack_public_path__ + "static/media/computer-image.3e893cca.jpg";